import { createFakeCanvas } from "@/utils/spritesheet";
import { LitElement, html } from "lit-element";
import { customElement, property } from "lit/decorators.js";
import { ModalScreen } from "./modal-screen";
import gameApp from "@/index";

@customElement("user-viewer")
export class UserViewer extends LitElement {
  @property({ type: Boolean }) open = false;
  @property({ type: Number }) id: any = null;
  @property({ type: String }) thumbnailUrl = "";
  clientId: string;
  username: string;

  constructor() {
    super();
  }

  protected createRenderRoot() {
    return this;
  }

  openView() {
    this.open = true;
  }

  closeView() {
    this.open = false;
  }

  async modify(properties: {
    username?: string;
    clientId?: string;
    thumbnail?: any;
  }) {
    if (properties.clientId !== undefined) this.clientId = properties.clientId;
    if (properties.username !== undefined) this.username = properties.username;

    this.setThumbnail(properties.thumbnail);
  }

  private async setThumbnail(thumbnail: any) {
    this.thumbnailUrl = await thumbnail;
  }

  get hasModeratingPermission() {
    return true;
    // return hasRole("admin") || hasRole("moderator");
  }

  moderatorSettings() {
    const moderatorSettings = document.querySelector(
      "moderator-settings"
    ) as ModalScreen;

    moderatorSettings?.openModal(this.clientId);
  }

  render() {
    return html`
      <div class="furni_viewer ${this.open ? "open" : ""}">
        <button
          class=" furni_viewer__close"
          @click=${() => (this.open = false)}
        >
          <span>Close</span>
        </button>

        <h1 class="furni_viewer__title">${this.username}</h1>
        <div style="width: 100px; height: 100px; position: relative;">
          <div style="transform: translateX(50%); width: 50%;">
            ${this.thumbnailUrl}
          </div>
        </div>
        ${this.hasModeratingPermission
          ? html`
              <div class="furni_viewer__button-group">
                <button class="btn is-disabled" @click=${() => {}} disabled>
                  Edit
                </button>
                <button class="btn" @click="${() => this.moderatorSettings()}">
                  Mute
                </button>
                <button class="btn is-disabled" @click=${() => {}} disabled>
                  Kick
                </button>
                <button class="btn is-disabled" @click=${() => {}} disabled>
                  Ban
                </button>
              </div>
            `
          : ""}
      </div>
    `;
  }
}
